import * as z from "zod";

export const updateAdvancedProcessingSettings = {
  name: "updateAdvancedProcessingSettings" as const,
  input: z
    .object({
      compensationEnabled: z.boolean(),
      restockingEnabled: z.boolean(),
    })
    .refine(
      ({ compensationEnabled, restockingEnabled }) =>
        compensationEnabled || !restockingEnabled,
      {
        message:
          "Advanced restocking requires advanced compensation processing",
        path: ["restockingEnabled"],
      },
    ),
  output: z.object({
    compensationEnabled: z.boolean(),
    restockingEnabled: z.boolean(),
  }),
};
